// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1rem 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  border-top: 1px solid #e9ecef;
  padding: 1rem 1.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/app/shared/components/import-opening-inventory-prompt-modal/import-opening-inventory-prompt-modal.component.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB","sourcesContent":[".modal-header {\n  border-bottom: 1px solid #e9ecef;\n  padding: 1rem 1.5rem;\n}\n\n.modal-body {\n  padding: 1.5rem;\n}\n\n.modal-footer {\n  border-top: 1px solid #e9ecef;\n  padding: 1rem 1.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
